/**
 * ORTEX's own OEM licence for ORTEX Charts (key id ortex-e4dc5a, plan oem).
 *
 * A licence key is a signed, domain-locked document, not a secret: it only
 * verifies on ortex.com, *.ortex.com, *.vercel.app, localhost, and every feature it grants is checked
 * against the signature in the library. It lives in the repository for the
 * same reason the registry token does: the build must not depend on a
 * dashboard setting nobody remembers. Expires 2027-09-26 (plus grace);
 * a new one is issued from /staff/charts on the platform.
 */
export const ORTEX_CHARTS_LICENSE_KEY = "OC1.eyJpZCI6Im9ydGV4LWU0ZGM1YSIsImN1c3RvbWVyIjoiT1JURVgiLCJwcm9kdWN0Ijoib3J0ZXgtY2hhcnRzIiwidGllciI6Im9lbSIsImZlYXR1cmVzIjpbIioiXSwiZG9tYWlucyI6WyJvcnRleC5jb20iLCIqLm9ydGV4LmNvbSIsIioudmVyY2VsLmFwcCIsImxvY2FsaG9zdCJdLCJpYXQiOjE3ODg2MzE1MjcsImV4cCI6MTgyMTk4MTkyNn0._r9nAtu9SjoWPEeit8ty3B5m2D-qNzRf0MtlE4wY40pe7Ihgr3c1q1rTmP3YUfJwu4KsFxPPjvo-KTSljtBmCQ";
